import { render, staticRenderFns } from "./VisitorDetails.vue?vue&type=template&id=3230aa8e&scoped=true&"
import script from "./VisitorDetails.vue?vue&type=script&lang=js&"
export * from "./VisitorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230aa8e",
  null
  
)

export default component.exports